import { Injectable, signal } from "@angular/core";
import { IChatViewMetadata } from "@tylertech/tyler-api-types";
import { ChatFormBinding } from "../interfaces";

export interface FormChatRegistration
{
    view: IChatViewMetadata;
    binding(): ChatFormBinding | undefined;
}

@Injectable({ providedIn: "root" })
export class FormChatService
{
    private readonly registered = signal<FormChatRegistration | undefined>(undefined);

    readonly chat = this.registered.asReadonly();

    register(registration: FormChatRegistration): void
    {
        this.registered.set(registration);
    }

    clear(view: IChatViewMetadata): void
    {
        if (this.registered()?.view === view)
            this.registered.set(undefined);
    }
}
